import React from "react";
import { Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const instagramPosts = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618318/img/private_jet_tarmac_elite.png",
  alt: "Elite private jet parked on the tarmac during golden hour"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618318/img/private_jet_in_flight_luxury.png",
  alt: "Luxury private jet in flight above the clouds"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618318/img/private_jet_alps.png",
  alt: "Elite private jet soaring over the snow-capped Alps"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618318/img/island_beach.png",
  alt: "Gourmet inflight dining service at thirty thousand feet"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618318/img/aircraft_exterior_sunset.png",
  alt: "Sleek aircraft silhouette against a deep orange sunset"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618318/img/private_jet_takeoff.png",
  alt: "Luxury private jet soaring over the New York City skyline at dusk"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618318/img/hangar_dusk_lighting.png",
  alt: "Aviation precision in a dusk-lit hangar facility"
}, {
  id: 8,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1618318/img/global_destination_aerial.png",
  alt: "The world delivered: aerial view of a coastal destination"
}];
export default function QueenslandMoments() {
  return <section data-section-id="20722" id="the-experience" className="dark bg-background py-20 px-8 w-full">
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        {}
        <div className="text-center mb-12">
          <h2 className="font-sans text-4xl md:text-5xl font-extrabold text-foreground mb-4 tracking-tighter uppercase">
            The Experience
          </h2>
          <p className="font-sans text-muted-foreground max-w-2xl mx-auto tracking-wide">
            Precision in every detail. Discover the lifestyle of elite aviation 
            and the silent luxury of global travel.
          </p>
        </div>

        {}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 w-full mb-12">
          {instagramPosts.map((post, i) => <div key={post.id} data-index={i} className="group relative aspect-square overflow-hidden rounded-none bg-secondary border border-border/50 shadow-2xl">
              <img src={post.src} alt={post.alt} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105 desaturate-[0.2] group-hover:desaturate-0" />
              {}
              <div className="absolute inset-0 bg-primary/0 transition-colors duration-500 group-hover:bg-primary/10 backdrop-blur-[2px] opacity-0 group-hover:opacity-100" />
            </div>)}
        </div>

        {}
        <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-none px-10 font-bold tracking-widest uppercase transition-all duration-300 shadow-lg hover:shadow-primary/20">
          <Link to="https://www.instagram.com/starboardaviationgroup/" newTab>
            <Instagram className="mr-2 h-5 w-5" />
            Follow Our Journey
          </Link>
        </Button>
      </div>
    </section>;
}